(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function TeamSection(elem) {
        Behaviors.init(TeamSection, this, arguments);

        var $thisElem = this.$elem,
            nav = $thisElem.find('.TeamSection-team_nav'),
            navItem = $thisElem.find('.TeamSection-team_nav_item a'),
            navDropdown = $thisElem.find('.TeamSection-team_nav_mobile_button');

        // Team Filters
        navItem.on("click", function (e) {
            e.preventDefault();

            var department = $(this).data('department');

            // Remove Active Class
            $('.TeamSection-team_nav_item--active').removeClass('TeamSection-team_nav_item--active');

            // Add Active Class
            $(this).parent().addClass('TeamSection-team_nav_item--active');

            nav.removeClass('TeamSection-team_nav--open');

            $.ajax({
                url: theme_ajax_url, // AJAX handler
                data: {
                    'action': 'team_filters',
                    department: department
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    $thisElem.addClass('TeamSection-team--loading');
                },
                success: function (data) {
                    $thisElem.find('.TeamSection-team_members').html(data);

                    $thisElem.removeClass('TeamSection-team--loading');
                }
            });
            return false;
        });

        // Team Mobile Dropdown
        navDropdown.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(this).parent().toggleClass('TeamSection-team_nav--open');
        });

        $(document).on('click', function() {
            nav.removeClass('TeamSection-team_nav--open');
        });
    }

    Behaviors.inherit(TeamSection, Behaviors.Behavior);

    TeamSection.QUERY = "[data-team-filters]";

    Behaviors.register_behavior(TeamSection);

    module.TeamSection = TeamSection;

    return module;

}(window.jQuery, window.Behaviors));